(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarMarquee extends HTMLElement {
    constructor() {
      super();
      this.embla = null;
      this.emblaOptions = null;
      this.emblaPlugins = null;
      this.resizeObserver = null;
      this.resizeTimeout = null;
      this.abortController = new AbortController();
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-announcement-viewport]');
      this.container = this.querySelector('[data-announcement-container]');
      this.mode = this.dataset.mode || 'marquee';

      if (!this.viewport || !this.container) return;

      if (this.mode === 'marquee') {
        this.sourceSlides = Array.from(
          this.container.querySelectorAll('[data-source-slide="true"]')
        );

        if (!this.sourceSlides.length) return;

        this.fillTrackWidth();
        this.setupResizeObserver();
      } else {
        this.prevBtn = this.querySelector('[data-announcement-prev]');
        this.nextBtn = this.querySelector('[data-announcement-next]');
      }

      this.initializeEmbla();
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.stopAutoPlay();

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }

      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }

      this.destroyEmbla();
    }

    async initializeEmbla() {
      if (this.mode === 'marquee' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      try {
        await this.loadEmblaScripts();
        this.createEmbla();
      } catch (error) {
        console.error('Announcement bar Embla failed to load:', error);
      }
    }

    loadScriptOnce(promiseKey, globalName, src) {
      if (window[globalName]) return Promise.resolve();
      if (window[promiseKey]) return window[promiseKey];

      window[promiseKey] = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[data-asset-src="${src}"]`);
        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.dataset.assetSrc = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window[promiseKey];
    }

    loadEmblaScripts() {
      const emblaSrc = this.dataset.emblaSrc;

      if (this.mode === 'slider') {
        return this.loadScriptOnce('__rhealEmblaCorePromise', 'EmblaCarousel', emblaSrc);
      }

      const autoScrollSrc = this.dataset.autoScrollSrc;
      return Promise.all([
        this.loadScriptOnce('__rhealEmblaCorePromise', 'EmblaCarousel', emblaSrc),
        this.loadScriptOnce('__rhealEmblaAutoScrollPromise', 'EmblaCarouselAutoScroll', autoScrollSrc)
      ]);
    }

    mapDurationToSpeed(duration) {
      if (!Number.isFinite(duration) || duration <= 0) return 2;
      const mappedSpeed = 60 / duration;
      return Math.min(6, Math.max(1, Number(mappedSpeed.toFixed(2))));
    }

    createEmbla() {
      if (typeof EmblaCarousel !== 'function') return;

      if (this.mode === 'slider') {
        var hasMultiple = this.container.children.length > 1;
        this.emblaOptions = { loop: hasMultiple, align: 'center' };
        this.emblaPlugins = [];
        this.embla = EmblaCarousel(this.viewport, this.emblaOptions, this.emblaPlugins);
        this.setupSliderNav();
        return;
      }

      if (typeof EmblaCarouselAutoScroll !== 'function') return;

      const direction = this.dataset.direction === 'right' ? 'backward' : 'forward';
      const duration = Number.parseFloat(this.dataset.duration || '24');
      const speed = this.mapDurationToSpeed(duration);
      const pauseOnHover = this.dataset.pauseOnHover === 'true';

      this.emblaOptions = {
        loop: true,
        dragFree: true,
        watchDrag: false,
        containScroll: 'trimSnaps'
      };

      this.emblaPlugins = [
        EmblaCarouselAutoScroll({
          direction,
          speed,
          startDelay: 0,
          playOnInit: true,
          stopOnMouseEnter: pauseOnHover,
          stopOnFocusIn: pauseOnHover,
          stopOnInteraction: false
        })
      ];

      this.embla = EmblaCarousel(this.viewport, this.emblaOptions, this.emblaPlugins);
    }

    setupSliderNav() {
      if (!this.embla) return;
      var signal = this.abortController.signal;
      var self = this;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function() {
          self.embla.scrollPrev();
          self.resetAutoPlay();
        }, { signal: signal });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function() {
          self.embla.scrollNext();
          self.resetAutoPlay();
        }, { signal: signal });
      }

      var interval = parseInt(this.dataset.sliderInterval, 10);
      if (interval > 0) {
        this.autoPlayDelay = interval * 1000;
        this.startAutoPlay();
      }
    }

    startAutoPlay() {
      this.stopAutoPlay();
      var self = this;
      this.autoPlayTimer = window.setInterval(function() {
        if (self.embla) self.embla.scrollNext();
      }, this.autoPlayDelay);
    }

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        window.clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    }

    resetAutoPlay() {
      if (this.autoPlayDelay) {
        this.startAutoPlay();
      }
    }

    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.resizeTimeout) {
          window.clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = window.setTimeout(() => {
          this.fillTrackWidth();

          if (this.embla && this.emblaOptions && this.emblaPlugins) {
            this.embla.reInit(this.emblaOptions, this.emblaPlugins);
          }
        }, 120);
      });

      this.resizeObserver.observe(this.viewport);
    }

    fillTrackWidth() {
      this.container
        .querySelectorAll('[data-generated-clone="true"]')
        .forEach((clone) => clone.remove());

      const viewportWidth = this.viewport.clientWidth;
      if (!viewportWidth) return;

      const targetWidth = viewportWidth * 2;
      let passes = 0;
      const maxPasses = 12;

      while (this.container.scrollWidth < targetWidth && passes < maxPasses) {
        this.sourceSlides.forEach((sourceSlide) => {
          const clone = sourceSlide.cloneNode(true);
          this.prepareClone(clone);
          this.container.appendChild(clone);
        });

        passes += 1;
      }
    }

    prepareClone(clone) {
      clone.dataset.generatedClone = 'true';
      clone.removeAttribute('data-source-slide');
      clone.removeAttribute('data-block-id');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });
    }

    destroyEmbla() {
      if (this.embla && typeof this.embla.destroy === 'function') {
        this.embla.destroy();
      }

      this.embla = null;
    }
  }

  if (!customElements.get('announcement-bar-marquee')) {
    customElements.define('announcement-bar-marquee', AnnouncementBarMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-disclaimer"] && !Shopify.designMode) return;
  try {
    
  class ArticleDisclaimer extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.runningAnimations = new WeakMap();
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      if (this.abortController.signal.aborted) {
        this.abortController = new AbortController();
      }

      this.initialize();
    }

    initialize() {
      const accordion = this.querySelector('[data-article-disclaimer-accordion]');
      if (!accordion) return;

      const isSingleOpen = accordion.dataset.singleOpen === 'true';
      const items = Array.from(accordion.querySelectorAll('.article-disclaimer__item'));
      if (!items.length) return;

      const { signal } = this.abortController;

      items.forEach((item) => {
        const panel = item.querySelector('.article-disclaimer__panel');
        if (!panel) return;

        if (item.open) {
          panel.style.height = 'auto';
          panel.style.opacity = '1';
        } else {
          panel.style.height = '0px';
          panel.style.opacity = '0';
        }

        const trigger = item.querySelector('.article-disclaimer__trigger');
        if (!trigger) return;

        trigger.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            this.toggleItem(item, items, isSingleOpen);
          },
          { signal }
        );

        trigger.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;

            event.preventDefault();
            this.toggleItem(item, items, isSingleOpen);
          },
          { signal }
        );
      });
    }

    toggleItem(item, items, isSingleOpen) {
      if (this.runningAnimations.get(item)) return;

      if (item.open) {
        this.closeItem(item);
        return;
      }

      if (isSingleOpen) {
        items.forEach((otherItem) => {
          if (otherItem !== item && otherItem.open) {
            this.closeItem(otherItem);
          }
        });
      }

      this.openItem(item);
    }

    openItem(item) {
      const panel = item.querySelector('.article-disclaimer__panel');
      if (!panel) return;

      const currentAnimation = this.runningAnimations.get(item);
      if (currentAnimation) {
        panel.removeEventListener('transitionend', currentAnimation);
      }

      item.open = true;
      panel.style.transition = 'none';
      panel.style.height = '0px';
      panel.style.opacity = '0';
      void panel.offsetHeight;

      const targetHeight = panel.scrollHeight;
      if (this.prefersReducedMotion) {
        panel.style.transition = '';
        panel.style.height = 'auto';
        panel.style.opacity = '1';
        this.runningAnimations.delete(item);
        return;
      }

      panel.style.transition = 'height 320ms cubic-bezier(0.4, 0, 0.2, 1), opacity 220ms cubic-bezier(0.4, 0, 0.2, 1)';
      panel.style.height = `${targetHeight}px`;
      panel.style.opacity = '1';

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        panel.style.transition = '';
        panel.style.height = 'auto';
        this.runningAnimations.delete(item);
        panel.removeEventListener('transitionend', onEnd);
      };

      this.runningAnimations.set(item, onEnd);
      panel.addEventListener('transitionend', onEnd);
    }

    closeItem(item) {
      const panel = item.querySelector('.article-disclaimer__panel');
      if (!panel) return;

      const currentAnimation = this.runningAnimations.get(item);
      if (currentAnimation) {
        panel.removeEventListener('transitionend', currentAnimation);
      }

      const startHeight = panel.offsetHeight;
      panel.style.transition = 'none';
      panel.style.height = `${startHeight}px`;
      panel.style.opacity = '1';
      void panel.offsetHeight;

      panel.style.transition = 'height 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)';
      panel.style.height = '0px';
      panel.style.opacity = '0';

      if (this.prefersReducedMotion) {
        item.open = false;
        panel.style.transition = '';
        panel.style.height = '0px';
        this.runningAnimations.delete(item);
        return;
      }

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        item.open = false;
        panel.style.transition = '';
        panel.style.height = '0px';
        this.runningAnimations.delete(item);
        panel.removeEventListener('transitionend', onEnd);
      };

      this.runningAnimations.set(item, onEnd);
      panel.addEventListener('transitionend', onEnd);
    }

    disconnectedCallback() {
      const panels = this.querySelectorAll('.article-disclaimer__panel');
      panels.forEach((panel) => {
        panel.style.transition = '';
      });

      this.runningAnimations = new WeakMap();
      this.abortController.abort();
    }
  }

  if (!customElements.get('article-disclaimer')) {
    customElements.define('article-disclaimer', ArticleDisclaimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-timeline"] && !Shopify.designMode) return;
  try {
    
  class BenefitsTimelineScroll extends HTMLElement {
    constructor() {
      super();
      this.cleanup = null;
    }

    connectedCallback() {
      this.list = this.querySelector('.benefits-timeline__list');
      if (!this.list) return;

      this.markers = [...this.list.querySelectorAll('.benefits-timeline__marker')];
      if (!this.markers.length) return;

      this.measureLine();

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.activateAll();
        return;
      }

      this.tryInit();
    }

    disconnectedCallback() {
      if (this.cleanup && typeof this.cleanup === 'function') {
        this.cleanup();
      }
      this.cleanup = null;
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
    }

    measureLine() {
      var list = this.list;
      var markers = this.markers;
      if (!list || markers.length < 2) return;

      var update = function() {
        var listRect = list.getBoundingClientRect();
        var firstCenter = markers[0].getBoundingClientRect().top - listRect.top + 10;
        var lastCenter = markers[markers.length - 1].getBoundingClientRect().top - listRect.top + 10;
        list.style.setProperty('--timeline-line-top', firstCenter + 'px');
        list.style.setProperty('--timeline-line-height', (lastCenter - firstCenter) + 'px');
      };

      update();

      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(update);
        this._resizeObserver.observe(list);
      }
    }

    tryInit() {
      if (window.Motion && typeof window.Motion.scroll === 'function') {
        this.initScrollAnimation();
        return;
      }

      if (document.readyState === 'complete') {
        this.activateAll();
      } else {
        window.addEventListener('load', () => this.tryInit(), { once: true });
      }
    }

    initScrollAnimation() {
      const list = this.list;
      const markers = this.markers;
      const count = markers.length;

      this.cleanup = window.Motion.scroll(
        (progress) => {
          list.style.setProperty('--timeline-progress', progress);

          for (let i = 0; i < count; i++) {
            const threshold = count > 1 ? i / (count - 1) : 0;
            if (progress >= threshold * 0.9) {
              markers[i].classList.add('is-active');
            } else {
              markers[i].classList.remove('is-active');
            }
          }
        },
        {
          target: this,
          offset: ['start 0.8', 'end end']
        }
      );
    }

    activateAll() {
      if (this.list) {
        this.list.style.setProperty('--timeline-progress', '1');
      }
      this.markers.forEach((m) => m.classList.add('is-active'));
    }
  }

  if (!customElements.get('benefits-timeline-scroll')) {
    customElements.define('benefits-timeline-scroll', BenefitsTimelineScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
  class CustomCollection extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
    }

    connectedCallback() {
      this.grid = this.querySelector('[data-cc-grid]');
      this.cards = Array.from(this.querySelectorAll('[data-cc-card]'));
      this.emptyState = this.querySelector('[data-cc-empty]');
      this.toggleButtons = Array.from(this.querySelectorAll('.cc-toggle__btn'));
      this.filterInputs = Array.from(this.querySelectorAll('[data-cc-filter]'));
      this.clearButton = this.querySelector('[data-cc-clear-filters]');
      this.clearWrap = this.querySelector('[data-cc-clear-wrap]');
      this.sortSelect = this.querySelector('[data-cc-sort]');
      this.sidebar = this.querySelector('[data-cc-sidebar]');
      this.openFiltersBtn = this.querySelector('[data-cc-open-filters]');
      this.closeFiltersBtn = this.querySelector('[data-cc-close-filters]');
      this.groupToggles = Array.from(this.querySelectorAll('[data-cc-group-toggle]'));

      this.currencySymbol = this.detectCurrencySymbol();
      this.currentType = 'subscription';
      this.originalOrder = this.cards.slice();

      this.readInitialFiltersFromUrl();
      this.setInitialFilterGroupState();
      this.applyPurchaseType(this.currentType, false);
      this.applyFilters();
      this.bindEvents();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    bindEvents() {
      const { signal } = this.abortController;

      this.toggleButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.onToggleClick(btn), { signal });
      });

      this.filterInputs.forEach((input) => {
        input.addEventListener('change', () => this.onFilterChange(), { signal });
      });

      if (this.clearButton) {
        this.clearButton.addEventListener('click', () => this.clearFilters(), { signal });
      }

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.applySort(), { signal });
      }

      if (this.openFiltersBtn) {
        this.openFiltersBtn.addEventListener('click', () => this.openFilters(), { signal });
      }

      if (this.closeFiltersBtn) {
        this.closeFiltersBtn.addEventListener('click', () => this.closeFilters(), { signal });
      }

      this.groupToggles.forEach((btn) => {
        btn.addEventListener('click', () => this.toggleGroup(btn), { signal });
      });
    }

    setInitialFilterGroupState() {
      this.querySelectorAll('[data-cc-filter-group]').forEach((group) => {
        const toggle = group.querySelector('[data-cc-group-toggle]');
        const isOpen = toggle ? toggle.getAttribute('aria-expanded') !== 'false' : true;
        group.setAttribute('data-cc-open', isOpen ? 'true' : 'false');
      });
    }

    toggleGroup(button) {
      const group = button.closest('[data-cc-filter-group]');
      if (!group) return;
      const isOpen = group.getAttribute('data-cc-open') === 'true';
      const nextOpen = !isOpen;
      group.setAttribute('data-cc-open', nextOpen ? 'true' : 'false');
      button.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
    }

    onToggleClick(button) {
      const type = button.dataset.purchaseType;
      if (!type || type === this.currentType) return;
      this.currentType = type;
      this.toggleButtons.forEach((btn) => {
        const isActive = btn === button;
        btn.classList.toggle('cc-toggle__btn--active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      this.applyPurchaseType(type, true);
    }

    applyPurchaseType(type, animate) {
      const isSubscription = type === 'subscription';

      this.cards.forEach((card) => {
        this.updateCardPrice(card, isSubscription);
        this.updateCardForm(card, isSubscription);
      });
    }

    updateCardPrice(card, isSubscription) {
      const priceEl = card.querySelector('[data-cc-price]');
      if (!priceEl) return;

      const soldOutEl = priceEl.querySelector('.cc-card__price-soldout');
      if (soldOutEl) return; // Sold out — nothing to swap.

      const hasSub = card.dataset.hasSubscription === 'true';
      const currentEl = priceEl.querySelector('[data-cc-price-current]');
      const compareEl = priceEl.querySelector('[data-cc-price-compare]');

      let displayCents;
      let compareCents = 0;

      if (isSubscription && hasSub) {
        displayCents = parseInt(card.dataset.subscriptionPrice, 10);
      } else {
        displayCents = parseInt(card.dataset.onetimePrice, 10);
        compareCents = parseInt(card.dataset.onetimeCompare, 10) || 0;
      }

      if (currentEl && !isNaN(displayCents)) {
        currentEl.textContent = this.formatMoney(displayCents);
      }

      if (compareEl) {
        if (!isSubscription && compareCents > displayCents) {
          compareEl.textContent = this.formatMoney(compareCents);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      } else if (!isSubscription && compareCents > displayCents) {
        const span = document.createElement('span');
        span.className = 'cc-card__price-compare';
        span.setAttribute('data-cc-price-compare', '');
        span.textContent = this.formatMoney(compareCents);
        priceEl.appendChild(span);
      }
    }

    updateCardForm(card, isSubscription) {
      const planInput = card.querySelector('[data-cc-selling-plan]');
      if (!planInput) return;

      const hasSub = card.dataset.hasSubscription === 'true';
      const planId = card.dataset.sellingPlanId || '';

      if (isSubscription && hasSub && planId) {
        planInput.name = 'selling_plan';
        planInput.value = planId;
      } else {
        planInput.name = '';
        planInput.value = '';
      }
    }

    onFilterChange() {
      this.applyFilters();
    }

    clearFilters() {
      this.filterInputs.forEach((input) => {
        if (input.checked) input.checked = false;
      });
      this.applyFilters();
    }

    applyFilters() {
      const selected = { category: new Set(), goal: new Set() };
      this.filterInputs.forEach((input) => {
        if (!input.checked) return;
        const key = input.dataset.filterKey;
        const value = input.dataset.filterValue;
        if (!key || !value) return;
        if (!selected[key]) selected[key] = new Set();
        selected[key].add(value);
      });

      const hasActive = selected.category.size > 0 || selected.goal.size > 0;
      if (this.clearWrap) this.clearWrap.hidden = !hasActive;

      let visibleCount = 0;

      this.cards.forEach((card) => {
        const cardCategories = (card.dataset.categories || '').split(/\s+/).filter(Boolean);
        const cardGoals = (card.dataset.goals || '').split(/\s+/).filter(Boolean);

        const catOk =
          selected.category.size === 0 ||
          cardCategories.some((v) => selected.category.has(v));
        const goalOk =
          selected.goal.size === 0 ||
          cardGoals.some((v) => selected.goal.has(v));

        const shouldShow = catOk && goalOk;
        card.hidden = !shouldShow;
        if (shouldShow) visibleCount++;
      });

      if (this.emptyState) {
        this.emptyState.hidden = visibleCount > 0;
      }
    }

    applySort() {
      if (!this.grid || !this.sortSelect) return;
      const value = this.sortSelect.value;

      let sorted;
      if (value === 'relevance') {
        sorted = this.originalOrder.slice();
      } else {
        sorted = this.cards.slice().sort((a, b) => {
          if (value === 'price-asc' || value === 'price-desc') {
            const priceKey =
              this.currentType === 'subscription' ? 'subscriptionPrice' : 'onetimePrice';
            const pa = parseInt(a.dataset[priceKey], 10) || 0;
            const pb = parseInt(b.dataset[priceKey], 10) || 0;
            return value === 'price-asc' ? pa - pb : pb - pa;
          }
          if (value === 'title-asc' || value === 'title-desc') {
            const ta = (a.dataset.title || '').toLowerCase();
            const tb = (b.dataset.title || '').toLowerCase();
            if (ta < tb) return value === 'title-asc' ? -1 : 1;
            if (ta > tb) return value === 'title-asc' ? 1 : -1;
            return 0;
          }
          return 0;
        });
      }

      const frag = document.createDocumentFragment();
      sorted.forEach((card) => frag.appendChild(card));
      this.grid.appendChild(frag);
    }

    readInitialFiltersFromUrl() {
      try {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const preselected = { category: new Set(), goal: new Set() };

        // Backward-compat: Rebuy-style ?rb_metafields=product.custom.<key>.<Value>
        const rbValues = params.getAll('rb_metafields');
        rbValues.forEach((raw) => {
          if (!raw) return;
          const parts = raw.split('.');
          if (parts.length < 4) return;
          const key = parts[2];
          const value = parts.slice(3).join('.');
          if (!value) return;
          const handled = this.handleize(value.replace(/\+/g, ' '));
          if (key === 'collection_category') preselected.category.add(handled);
          else if (key === 'collection_goal_filter') preselected.goal.add(handled);
        });

        // New format: ?filter.category=slug&filter.goal=slug (multi-value repeat)
        params.getAll('filter.category').forEach((v) => v && preselected.category.add(this.handleize(v)));
        params.getAll('filter.goal').forEach((v) => v && preselected.goal.add(this.handleize(v)));

        this.filterInputs.forEach((input) => {
          const key = input.dataset.filterKey;
          const value = input.dataset.filterValue;
          if (preselected[key] && preselected[key].has(value)) {
            input.checked = true;
          }
        });
      } catch (err) {
        // No-op; if URL parsing fails, just skip pre-selection.
      }
    }

    handleize(str) {
      return String(str)
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-');
    }

    openFilters() {
      if (!this.sidebar) return;
      this.sidebar.classList.add('is-open');
      document.documentElement.classList.add('cc-filters-open');
      if (this.openFiltersBtn) this.openFiltersBtn.setAttribute('aria-expanded', 'true');
    }

    closeFilters() {
      if (!this.sidebar) return;
      this.sidebar.classList.remove('is-open');
      document.documentElement.classList.remove('cc-filters-open');
      if (this.openFiltersBtn) this.openFiltersBtn.setAttribute('aria-expanded', 'false');
    }

    detectCurrencySymbol() {
      const sampleCard = this.cards.find((card) => card.querySelector('[data-cc-price-current]'));
      const sample = sampleCard?.querySelector('[data-cc-price-current]')?.textContent || '';
      const symbol = sample.replace(/[\d.,\s]/g, '');
      return symbol || '$';
    }

    formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      const value = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return `${this.currencySymbol}${value}`;
    }
  }

  if (!customElements.get('custom-collection')) {
    customElements.define('custom-collection', CustomCollection);
  }

  // ---------------------------------------------------------------
  // <product-form> AJAX add-to-cart element.
  // Duplicated from snippets/product-card.liquid because Shopify only
  // ships a snippet's script block on templates that render it,
  // and no section on this template renders product-card. The
  // customElements.get() guard makes the double-define safe when
  // both bundles do load (e.g., PDP recommendation grids).
  // ---------------------------------------------------------------
  // TEMP DEBUG: remove once loader is confirmed working.
  const CC_DBG = (...args) => console.log('[CC-ATC]', ...args);
  CC_DBG('ProductForm module evaluated');

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      CC_DBG('constructor', this);
    }

    connectedCallback() {
      CC_DBG('connectedCallback', this, 'children:', this.children.length);
      // Listen at capture phase so we win over any third-party submit
      // interceptors (Rebuy / Shopify Analytics etc.).
      this.addEventListener('submit', this.handleSubmit.bind(this), true);
      // Also delegate on click for the submit button — some pages
      // stop the submit event before it bubbles, so this is our
      // reliable path.
      this.addEventListener('click', (event) => {
        const btn = event.target && event.target.closest && event.target.closest('button[type="submit"], input[type="submit"]');
        if (!btn || !this.contains(btn)) return;
        CC_DBG('click on submit button', btn);
        event.preventDefault();
        event.stopPropagation();
        this._runAdd(btn);
      }, true);
    }

    async handleSubmit(event) {
      CC_DBG('handleSubmit fired', {
        target: event.target,
        submitter: event.submitter,
        currentTarget: event.currentTarget,
      });

      const form = event.target && event.target.tagName === 'FORM'
        ? event.target
        : this.querySelector('form');
      if (!form) {
        CC_DBG('no form found — aborting');
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const btn =
        (event.submitter && event.submitter.matches('button[type="submit"], input[type="submit"]')
          ? event.submitter
          : form.querySelector('button[type="submit"], input[type="submit"]'));
      return this._runAdd(btn);
    }

    async _runAdd(button) {
      const form = this.querySelector('form');
      if (!form || !button) {
        CC_DBG('_runAdd missing form/button', { form, button });
        return;
      }
      this.form = form;
      this.submitButton = button;
      CC_DBG('resolved button', this.submitButton);
      if (!this.submitButton || !this.form) return;

      // Ensure the button has a label span + spinner span. If the
      // rendered HTML is stale (predates the loader markup), inject
      // them now so text swaps don't clobber the spinner.
      let spinnerEl = this.submitButton.querySelector('.cc-card__button-spinner');
      let labelEl = this.submitButton.querySelector('.cc-card__button-label');
      CC_DBG('spans present?', { spinner: !!spinnerEl, label: !!labelEl });
      if (!labelEl) {
        CC_DBG('injecting label + spinner spans (stale HTML fallback)');
        const existingText = this.submitButton.textContent.trim();
        this.submitButton.textContent = '';
        spinnerEl = document.createElement('span');
        spinnerEl.className = 'cc-card__button-spinner';
        spinnerEl.setAttribute('aria-hidden', 'true');
        labelEl = document.createElement('span');
        labelEl.className = 'cc-card__button-label';
        labelEl.textContent = existingText || 'Add to Cart';
        this.submitButton.appendChild(spinnerEl);
        this.submitButton.appendChild(labelEl);
      }

      const formData = new FormData(this.form);
      const originalText = labelEl.textContent;
      const MIN_SPINNER_MS = 500;
      const startedAt = Date.now();
      const waitMinDuration = () =>
        new Promise((resolve) => {
          const elapsed = Date.now() - startedAt;
          const remaining = Math.max(0, MIN_SPINNER_MS - elapsed);
          setTimeout(resolve, remaining);
        });

      labelEl.textContent = 'Adding...';
      this.submitButton.classList.add('is-loading');
      this.submitButton.disabled = true;
      CC_DBG('applied is-loading', {
        classList: [...this.submitButton.classList],
        outerHTML: this.submitButton.outerHTML.slice(0, 240),
        spinnerComputedDisplay: spinnerEl ? getComputedStyle(spinnerEl).display : 'no-spinner',
      });

      try {
        const id = formData.get('id');
        const sellingPlan = formData.get('selling_plan');
        const isSubscription = sellingPlan && String(sellingPlan).trim() !== '';
        const subscriptionGiftId = window.RhealGifts && window.RhealGifts.subscriptionGiftId;
        const isGiftItself = !!(window.RhealGifts && window.RhealGifts.isGift(id));

        let fetchInit;
        if (isSubscription && !isGiftItself) {
          const primary = { id: Number(id), quantity: Number(formData.get('quantity') || 1), selling_plan: Number(sellingPlan) };
          const items = [primary];
          if (subscriptionGiftId) items.push({ id: Number(subscriptionGiftId), quantity: 1 });
          fetchInit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          };
        } else {
          fetchInit = { method: 'POST', body: formData };
        }

        const response = await fetch('/cart/add.js', fetchInit);

        if (response.ok) {
          // theme.liquid's fetch wrapper has already:
          //   (a) injected the free-gift line into the same POST when this
          //       add carried a selling_plan (subscribe path), and
          //   (b) scheduled a debounced reconciliation pass that removes
          //       any orphaned gift when the cart has no subscription
          //       (downgrade to one-time path).
          // We wait for reconciliation to complete before opening the
          // Rebuy drawer so it never renders a stale cart state.
          await Promise.race([
            new Promise((resolve) => {
              const done = () => {
                document.removeEventListener('rheal:cart-reconciled', done);
                resolve();
              };
              document.addEventListener('rheal:cart-reconciled', done, { once: true });
            }),
            new Promise((resolve) => setTimeout(resolve, 1200)),
          ]);

          await waitMinDuration();

          labelEl.textContent = 'Added!';
          this.submitButton.classList.remove('is-loading');

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
            })
          );

          const openRebuyCart = () => {
            if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
              window.Rebuy.SmartCart.show();
              return true;
            }
            return false;
          };
          if (!openRebuyCart()) {
            const poll = setInterval(() => { if (openRebuyCart()) clearInterval(poll); }, 100);
            setTimeout(() => clearInterval(poll), 5000);
          }

          setTimeout(() => {
            labelEl.textContent = originalText;
            this.submitButton.disabled = false;
          }, 1500);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        labelEl.textContent = 'Error';
        this.submitButton.classList.remove('is-loading');

        setTimeout(() => {
          labelEl.textContent = originalText;
          this.submitButton.disabled = false;
        }, 2000);
      }
    }
  }

  if (!customElements.get('product-form')) {
    CC_DBG('defining product-form (this bundle wins)');
    customElements.define('product-form', ProductForm);
  } else {
    CC_DBG('product-form ALREADY defined by another bundle — this class will NOT run', {
      existing: customElements.get('product-form'),
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class FooterMenuAccordion extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.handleToggle = this.handleToggle.bind(this);
      this.handleMediaChange = this.handleMediaChange.bind(this);
      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.wasDesktop = null;
    }

    connectedCallback() {
      if (this.abortController.signal.aborted) {
        this.abortController = new AbortController();
      }

      this.details = Array.from(this.querySelectorAll('[data-footer-menu-item]'));
      this.singleOpen = this.dataset.singleOpen === 'true';

      if (!this.details.length) return;

      const { signal } = this.abortController;
      this.details.forEach((detail) => {
        detail.addEventListener('toggle', this.handleToggle, { signal });
      });

      if (typeof this.desktopMedia.addEventListener === 'function') {
        this.desktopMedia.addEventListener('change', this.handleMediaChange, { signal });
      } else {
        this.desktopMedia.addListener(this.handleMediaChange);
      }

      this.syncForViewport({ force: true });
    }

    handleMediaChange() {
      this.syncForViewport({ force: false });
    }

    isDesktop() {
      return this.desktopMedia.matches;
    }

    syncForViewport({ force }) {
      const desktop = this.isDesktop();

      if (desktop) {
        this.details.forEach((detail) => {
          detail.open = true;
        });
      } else if (force || this.wasDesktop) {
        this.details.forEach((detail) => {
          detail.open = detail.dataset.openMobileDefault === 'true';
        });

        if (this.singleOpen) {
          const openItems = this.details.filter((detail) => detail.open);
          openItems.forEach((detail, index) => {
            if (index > 0) detail.open = false;
          });
        }
      }

      this.wasDesktop = desktop;
    }

    handleToggle(event) {
      if (this.isDesktop() || !this.singleOpen) return;

      const openedItem = event.target;
      if (!openedItem.open) return;

      this.details.forEach((detail) => {
        if (detail !== openedItem) {
          detail.open = false;
        }
      });
    }

    disconnectedCallback() {
      if (typeof this.desktopMedia.removeEventListener === 'function') {
        this.desktopMedia.removeEventListener('change', this.handleMediaChange);
      } else {
        this.desktopMedia.removeListener(this.handleMediaChange);
      }

      this.abortController.abort();
    }
  }

  if (!customElements.get('footer-menu-accordion')) {
    customElements.define('footer-menu-accordion', FooterMenuAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroVideo extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
    }

    connectedCallback() {
      this.abortController = new AbortController();
      const video = this.querySelector('video');

      if (!video) return;

      const { signal } = this.abortController;

      /* Attempt autoplay; browsers may block it */
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          /* Autoplay was prevented - mute and retry */
          video.muted = true;
          video.play().catch(() => {});
        });
      }

      /* Pause when not visible for performance */
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          }
        },
        { threshold: 0.25 }
      );

      observer.observe(this);

      signal.addEventListener('abort', () => {
        observer.disconnect();
      });
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    }
  }

  if (!customElements.get('hero-video')) {
    customElements.define('hero-video', HeroVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos-auto-scrolling"] && !Shopify.designMode) return;
  try {
    
  class LogosAutoScrolling extends HTMLElement {
    constructor() {
      super();
      this.embla = null;
      this.emblaOptions = null;
      this.emblaPlugins = null;
      this.resizeObserver = null;
      this.resizeTimeout = null;
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-logos-viewport]');
      this.container = this.querySelector('[data-logos-container]');

      if (!this.viewport || !this.container) return;

      this.sourceSlides = Array.from(
        this.container.querySelectorAll('[data-source-slide="true"]')
      );

      if (!this.sourceSlides.length) return;

      this.fillTrackWidth();
      this.setupResizeObserver();
      this.initializeEmbla();
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }

      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }

      this.destroyEmbla();
    }

    async initializeEmbla() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      try {
        await this.loadEmblaScripts();
        this.createEmbla();
      } catch (error) {
        console.error('Logos auto scrolling Embla failed to load:', error);
      }
    }

    loadScriptOnce(promiseKey, globalName, src) {
      if (window[globalName]) return Promise.resolve();
      if (window[promiseKey]) return window[promiseKey];

      window[promiseKey] = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[data-asset-src="${src}"]`);
        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.dataset.assetSrc = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window[promiseKey];
    }

    loadEmblaScripts() {
      const emblaSrc = this.dataset.emblaSrc;
      const autoScrollSrc = this.dataset.autoScrollSrc;

      return Promise.all([
        this.loadScriptOnce('__rhealEmblaCorePromise', 'EmblaCarousel', emblaSrc),
        this.loadScriptOnce('__rhealEmblaAutoScrollPromise', 'EmblaCarouselAutoScroll', autoScrollSrc)
      ]);
    }

    mapDurationToSpeed(duration) {
      if (!Number.isFinite(duration) || duration <= 0) return 2;
      const mappedSpeed = 60 / duration;
      return Math.min(6, Math.max(1, Number(mappedSpeed.toFixed(2))));
    }

    createEmbla() {
      if (typeof EmblaCarousel !== 'function' || typeof EmblaCarouselAutoScroll !== 'function') {
        return;
      }

      const direction = this.dataset.direction === 'right' ? 'backward' : 'forward';
      const duration = Number.parseFloat(this.dataset.duration || '24');
      const speed = this.mapDurationToSpeed(duration);
      const pauseOnHover = this.dataset.pauseOnHover === 'true';

      this.emblaOptions = {
        loop: true,
        dragFree: true,
        watchDrag: false,
        containScroll: 'trimSnaps'
      };

      this.emblaPlugins = [
        EmblaCarouselAutoScroll({
          direction,
          speed,
          startDelay: 0,
          playOnInit: true,
          stopOnMouseEnter: pauseOnHover,
          stopOnFocusIn: pauseOnHover,
          stopOnInteraction: false
        })
      ];

      this.embla = EmblaCarousel(this.viewport, this.emblaOptions, this.emblaPlugins);
    }

    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.resizeTimeout) {
          window.clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = window.setTimeout(() => {
          this.fillTrackWidth();

          if (this.embla && this.emblaOptions && this.emblaPlugins) {
            this.embla.reInit(this.emblaOptions, this.emblaPlugins);
          }
        }, 120);
      });

      this.resizeObserver.observe(this.viewport);
    }

    fillTrackWidth() {
      this.container
        .querySelectorAll('[data-generated-clone="true"]')
        .forEach((clone) => clone.remove());

      const viewportWidth = this.viewport.clientWidth;
      if (!viewportWidth) return;

      const targetWidth = viewportWidth * 2;
      let passes = 0;
      const maxPasses = 12;

      while (this.container.scrollWidth < targetWidth && passes < maxPasses) {
        this.sourceSlides.forEach((sourceSlide) => {
          const clone = sourceSlide.cloneNode(true);
          this.prepareClone(clone);
          this.container.appendChild(clone);
        });

        passes += 1;
      }
    }

    prepareClone(clone) {
      clone.dataset.generatedClone = 'true';
      clone.removeAttribute('data-source-slide');
      clone.removeAttribute('data-block-id');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });
    }

    destroyEmbla() {
      if (this.embla && typeof this.embla.destroy === 'function') {
        this.embla.destroy();
      }

      this.embla = null;
    }
  }

  if (!customElements.get('logos-auto-scrolling')) {
    customElements.define('logos-auto-scrolling', LogosAutoScrolling);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  class MainArticleContent extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
    }

    connectedCallback() {
      if (this.abortController.signal.aborted) {
        this.abortController = new AbortController();
      }

      this.normalizeArticleBodies();
      this.injectCtaCard();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    injectCtaCard() {
      const ctaCard = this.querySelector('[data-article-cta]');
      const body = this.querySelector('[data-main-article-body]');
      if (!ctaCard || !body) return;

      const position = parseInt(ctaCard.dataset.ctaPosition, 10);
      if (!position || position < 1) return;

      const headings = body.querySelectorAll('h2, h3');
      const targetIndex = position - 1;

      if (headings.length > 0 && targetIndex < headings.length) {
        headings[targetIndex].before(ctaCard);
      } else if (headings.length > 0) {
        headings[headings.length - 1].after(ctaCard);
      } else {
        body.appendChild(ctaCard);
      }

      ctaCard.removeAttribute('hidden');
    }

    normalizeArticleBodies() {
      const articleBodies = this.querySelectorAll('[data-main-article-body]');
      if (!articleBodies.length) return;

      articleBodies.forEach((body) => {
        if (body.dataset.mainArticleNormalized === 'true') return;

        this.stripInlineStyles(body);
        this.trimBreakOnlyBlocks(body);
        this.trimBlockEdges(body);
        this.removeEmptyNodes(body);

        body.dataset.mainArticleNormalized = 'true';
      });
    }

    stripInlineStyles(root) {
      root.querySelectorAll('[style]').forEach((node) => {
        if (node.closest('[data-article-cta]')) return;
        node.removeAttribute('style');
      });
    }

    trimBreakOnlyBlocks(root) {
      root.querySelectorAll('h1, h2, h3, h4, h5, h6, p, li, div').forEach((node) => {
        while (node.firstChild?.nodeName === 'BR') {
          node.firstChild.remove();
        }

        while (node.lastChild?.nodeName === 'BR') {
          node.lastChild.remove();
        }
      });
    }

    trimBlockEdges(root) {
      root.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6').forEach((node) => {
        if (!node.firstChild || !node.lastChild) return;

        if (node.firstChild.nodeType === Node.TEXT_NODE) {
          node.firstChild.textContent = node.firstChild.textContent.replace(/^[\s\u00a0]+/, '');
        }

        if (node.lastChild.nodeType === Node.TEXT_NODE) {
          node.lastChild.textContent = node.lastChild.textContent.replace(/[\s\u00a0]+$/, '');
        }
      });
    }

    removeEmptyNodes(root) {
      const candidates = Array.from(
        root.querySelectorAll('a, b, div, em, h1, h2, h3, h4, h5, h6, i, p, span, strong')
      ).reverse();

      candidates.forEach((node) => {
        if (node.closest('[data-article-cta]')) return;
        const hasMedia = node.querySelector('img, iframe, video, svg');
        const normalizedText = node.textContent.replace(/\u00a0/g, ' ').trim();

        if (hasMedia || normalizedText !== '') return;

        node.remove();
      });
    }
  }

  if (!customElements.get('main-article-content')) {
    customElements.define('main-article-content', MainArticleContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    class MainCart {
      constructor(root) {
        this.root = root;
        this.sectionId = root.dataset.sectionId;
        this.statusEl = root.querySelector('[data-cart-status]');
        this.summaryEl = root.querySelector('[data-cart-summary]');
        this.toastEl = root.querySelector('[data-cart-toast]');
        this.toastMessageEl = root.querySelector('[data-cart-toast-message]');

        this.abortController = new AbortController();
        this.statusTimer = null;
        this.toastTimer = null;

        this.isBusy = false;
        this.undoPayload = null;

        this.bindEvents();
      }

      bindEvents() {
        const { signal } = this.abortController;

        this.root.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.root.addEventListener('change', (event) => this.handleChange(event), { signal });
        this.root.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      }

      destroy() {
        this.abortController.abort();

        if (this.statusTimer) {
          window.clearTimeout(this.statusTimer);
          this.statusTimer = null;
        }

        if (this.toastTimer) {
          window.clearTimeout(this.toastTimer);
          this.toastTimer = null;
        }
      }

      isIrelandMarket() {
        return this.root.dataset.irelandMarket === 'true';
      }

      getCartRoot() {
        return window.Shopify?.routes?.root || '/';
      }

      clampQuantity(value, min = 0) {
        const quantity = Number.parseInt(value, 10);

        if (Number.isNaN(quantity)) {
          return min;
        }

        return Math.max(min, quantity);
      }

      clearStatus() {
        if (!this.statusEl) {
          return;
        }

        this.statusEl.textContent = '';
        this.statusEl.classList.remove('is-visible', 'is-error');
      }

      setStatus(message = '', isError = false, transient = false) {
        if (!this.statusEl) {
          return;
        }

        if (this.statusTimer) {
          window.clearTimeout(this.statusTimer);
          this.statusTimer = null;
        }

        this.statusEl.textContent = message;
        this.statusEl.classList.toggle('is-error', isError);
        this.statusEl.classList.toggle('is-visible', message !== '');

        if (transient && message !== '') {
          this.statusTimer = window.setTimeout(() => {
            this.clearStatus();
          }, 2600);
        }
      }

      setElementDisabled(element, disabled) {
        if (!element) {
          return;
        }

        if ('disabled' in element) {
          element.disabled = disabled;
        } else if (disabled) {
          element.setAttribute('aria-disabled', 'true');
        } else {
          element.removeAttribute('aria-disabled');
        }
      }

      setAllControlsDisabled(disabled) {
        this.root.querySelectorAll('.main-cart__control').forEach((element) => {
          this.setElementDisabled(element, disabled);
        });
      }

      setSummaryPending(isPending) {
        if (this.summaryEl) {
          this.summaryEl.classList.toggle('is-pending', isPending);
        }

        this.root.querySelectorAll('[data-summary-control]').forEach((element) => {
          this.setElementDisabled(element, isPending);
        });
      }

      getLineElement(line) {
        return this.root.querySelector(`[data-cart-line="${line}"]`);
      }

      setLinePending(line, isPending) {
        const lineElement = this.getLineElement(line);

        if (!lineElement) {
          return;
        }

        lineElement.classList.toggle('is-pending', isPending);

        lineElement.querySelectorAll('.main-cart__control').forEach((element) => {
          this.setElementDisabled(element, isPending);
        });
      }

      getLineNumber(element) {
        const line = Number.parseInt(element.dataset.line, 10);

        if (Number.isNaN(line) || line < 1) {
          return null;
        }

        return line;
      }

      getQuantitySelect(line) {
        return this.root.querySelector(`[data-cart-action="quantity-select"][data-line="${line}"]`);
      }

      getCurrentLineQuantity(line, fallback = 1) {
        const select = this.getQuantitySelect(line);

        if (!select) {
          return fallback;
        }

        return this.clampQuantity(select.value, 1);
      }

      parseProperties(rawValue) {
        if (!rawValue) {
          return {};
        }

        try {
          const parsed = JSON.parse(rawValue);

          if (!parsed || typeof parsed !== 'object') {
            return {};
          }

          return Object.entries(parsed).reduce((accumulator, [key, value]) => {
            if (value === '' || value === null) {
              return accumulator;
            }

            accumulator[key] = value;
            return accumulator;
          }, {});
        } catch (_error) {
          return {};
        }
      }

      buildUndoPayload(button) {
        const lineElement = button.closest('.main-cart__item');

        if (!lineElement) {
          return null;
        }

        const variantId = Number.parseInt(lineElement.dataset.variantId, 10);

        if (Number.isNaN(variantId)) {
          return null;
        }

        const quantity = this.clampQuantity(lineElement.dataset.lineQuantity || 1, 1);
        const payload = {
          id: variantId,
          quantity,
        };

        const sellingPlanId = Number.parseInt(lineElement.dataset.sellingPlanId, 10);

        if (!Number.isNaN(sellingPlanId) && !this.isIrelandMarket()) {
          payload.selling_plan = sellingPlanId;
        }

        const properties = this.parseProperties(lineElement.dataset.properties);

        if (Object.keys(properties).length > 0) {
          payload.properties = properties;
        }

        return payload;
      }

      hideUndoToast() {
        this.undoPayload = null;

        if (!this.toastEl) {
          return;
        }

        if (this.toastTimer) {
          window.clearTimeout(this.toastTimer);
          this.toastTimer = null;
        }

        this.toastEl.classList.remove('is-visible');
        this.toastEl.hidden = true;
      }

      showUndoToast(payload) {
        if (!this.toastEl || !payload) {
          return;
        }

        this.undoPayload = payload;

        if (this.toastMessageEl) {
          this.toastMessageEl.textContent = 'Item removed.';
        }

        this.toastEl.hidden = false;
        this.toastEl.classList.add('is-visible');

        if (this.toastTimer) {
          window.clearTimeout(this.toastTimer);
        }

        this.toastTimer = window.setTimeout(() => {
          this.hideUndoToast();
        }, 6000);
      }

      async request(endpoint, payload, renderSection = false) {
        const body = { ...payload };

        if (renderSection && this.sectionId) {
          body.sections = this.sectionId;
          body.sections_url = `${window.location.pathname}${window.location.search}`;
        }

        const response = await fetch(`${this.getCartRoot()}${endpoint}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(body),
        });

        let data = {};

        try {
          data = await response.json();
        } catch (_error) {
          data = {};
        }

        if (!response.ok) {
          throw new Error(data?.description || data?.message || 'Unable to update cart.');
        }

        return data;
      }

      replaceSection(data, options = {}) {
        const nextMarkup = data?.sections?.[this.sectionId];

        if (!nextMarkup) {
          window.location.reload();
          return;
        }

        const parsed = new DOMParser().parseFromString(nextMarkup, 'text/html');
        const nextRoot = parsed.querySelector(`#MainCart-${this.sectionId}`);

        if (!nextRoot) {
          window.location.reload();
          return;
        }

        const { focusSelector = null, removedItemPayload = null, nextStatusMessage = '' } = options;

        this.destroy();
        this.root.replaceWith(nextRoot);

        const nextInstance = initializeMainCart(nextRoot);

        if (focusSelector) {
          const nextFocus = nextRoot.querySelector(focusSelector);

          if (nextFocus) {
            nextFocus.focus();
          }
        }

        if (nextStatusMessage && nextInstance) {
          nextInstance.setStatus(nextStatusMessage, false, true);
        }

        if (removedItemPayload && nextInstance) {
          nextInstance.showUndoToast(removedItemPayload);
        }
      }

      async updateLine(payload, options = {}) {
        if (this.isBusy) {
          this.setStatus('Please wait while your cart updates.');
          return;
        }

        const {
          line = payload.line,
          focusSelector = null,
          removedItemPayload = null,
          nextStatusMessage = '',
        } = options;

        this.isBusy = true;
        this.hideUndoToast();

        if (line) {
          this.setLinePending(line, true);
        }

        this.setSummaryPending(true);
        this.setStatus('Updating your cart...');

        try {
          const data = await this.request('cart/change.js', payload, true);
          this.replaceSection(data, {
            focusSelector,
            removedItemPayload,
            nextStatusMessage,
          });
        } catch (error) {
          this.isBusy = false;

          if (line) {
            this.setLinePending(line, false);
          }

          this.setSummaryPending(false);
          this.setStatus(error.message, true);
        }
      }

      async updateCart(payload, options = {}) {
        if (this.isBusy) {
          this.setStatus('Please wait while your cart updates.');
          return false;
        }

        const { renderSection = false, successMessage = 'Cart updated.', focusSelector = null } = options;

        this.isBusy = true;
        this.setAllControlsDisabled(true);
        this.setSummaryPending(true);
        this.setStatus('Updating your cart...');

        try {
          const data = await this.request('cart/update.js', payload, renderSection);

          if (renderSection) {
            this.replaceSection(data, {
              focusSelector,
              nextStatusMessage: successMessage,
            });
            return true;
          }

          this.isBusy = false;
          this.setAllControlsDisabled(false);
          this.setSummaryPending(false);
          this.setStatus(successMessage, false, true);
          return true;
        } catch (error) {
          this.isBusy = false;
          this.setAllControlsDisabled(false);
          this.setSummaryPending(false);
          this.setStatus(error.message, true);
          return false;
        }
      }

      handleQuantitySelectChange(select) {
        const line = this.getLineNumber(select);

        if (!line) {
          return;
        }

        const nextQuantity = this.clampQuantity(select.value, 1);
        const currentQuantity = this.clampQuantity(select.dataset.currentQuantity, 1);

        if (nextQuantity === currentQuantity) {
          return;
        }

        select.value = String(nextQuantity);
        select.dataset.currentQuantity = String(nextQuantity);

        this.updateLine(
          {
            line,
            quantity: nextQuantity,
          },
          {
            line,
            focusSelector: `[data-cart-action="quantity-select"][data-line="${line}"]`,
            nextStatusMessage: 'Quantity updated.',
          }
        );
      }

      handleSellingPlanChange(select) {
        if (this.isIrelandMarket()) {
          return;
        }

        const line = this.getLineNumber(select);

        if (!line) {
          return;
        }

        const quantity = this.getCurrentLineQuantity(line, 1);
        const sellingPlanValue = select.value;

        this.updateLine(
          {
            line,
            quantity,
            selling_plan: sellingPlanValue === '' ? null : Number.parseInt(sellingPlanValue, 10),
          },
          {
            line,
            focusSelector: `[data-cart-action="selling-plan"][data-line="${line}"]`,
            nextStatusMessage: 'Purchase option updated.',
          }
        );
      }

      handleApplyDiscount() {
        const input = this.root.querySelector('[data-cart-discount-input]');

        if (!input) {
          return;
        }

        const discount = input.value.trim();

        this.updateCart(
          {
            discount,
          },
          {
            renderSection: true,
            successMessage: discount ? 'Discount code applied.' : 'Discount code removed.',
            focusSelector: '[data-cart-discount-input]',
          }
        );
      }

      handleClearDiscount() {
        const input = this.root.querySelector('[data-cart-discount-input]');

        if (input) {
          input.value = '';
        }

        this.updateCart(
          {
            discount: '',
          },
          {
            renderSection: true,
            successMessage: 'Discounts cleared.',
            focusSelector: '[data-cart-discount-input]',
          }
        );
      }

      handleSaveNote() {
        const noteInput = this.root.querySelector('[data-cart-note]');

        if (!noteInput) {
          return;
        }

        const note = noteInput.value;
        const previousNote = noteInput.dataset.initialNote || '';

        if (note === previousNote) {
          this.setStatus('Note is already saved.', false, true);
          return;
        }

        this.updateCart(
          {
            note,
          },
          {
            renderSection: false,
            successMessage: 'Note saved.',
          }
        ).then((didSave) => {
          if (didSave) {
            noteInput.dataset.initialNote = note;
          }
        });
      }

      handleRemove(button) {
        const line = this.getLineNumber(button);

        if (!line) {
          return;
        }

        const removedItemPayload = this.buildUndoPayload(button);

        this.updateLine(
          {
            line,
            quantity: 0,
          },
          {
            line,
            removedItemPayload,
            nextStatusMessage: 'Item removed.',
          }
        );
      }

      async handleUndoRemove() {
        if (!this.undoPayload) {
          return;
        }

        if (this.isBusy) {
          this.setStatus('Please wait while your cart updates.');
          return;
        }

        const payload = { ...this.undoPayload };

        this.isBusy = true;
        this.hideUndoToast();
        this.setAllControlsDisabled(true);
        this.setSummaryPending(true);
        this.setStatus('Restoring item...');

        try {
          await this.request('cart/add.js', payload, false);
          const data = await this.request('cart/update.js', {}, true);
          this.replaceSection(data, {
            nextStatusMessage: 'Item restored.',
          });
        } catch (error) {
          this.isBusy = false;
          this.setAllControlsDisabled(false);
          this.setSummaryPending(false);
          this.setStatus(error.message, true);
        }
      }

      handleClick(event) {
        const actionElement = event.target.closest('[data-cart-action]');

        if (!actionElement) {
          return;
        }

        const action = actionElement.dataset.cartAction;

        if (action === 'remove') {
          event.preventDefault();
          this.handleRemove(actionElement);
          return;
        }

        if (action === 'apply-discount') {
          event.preventDefault();
          this.handleApplyDiscount();
          return;
        }

        if (action === 'clear-discount') {
          event.preventDefault();
          this.handleClearDiscount();
          return;
        }

        if (action === 'save-note') {
          event.preventDefault();
          this.handleSaveNote();
          return;
        }

        if (action === 'undo-remove') {
          event.preventDefault();
          this.handleUndoRemove();
        }
      }

      handleChange(event) {
        const target = event.target;

        if (!(target instanceof HTMLElement)) {
          return;
        }

        if (target.matches('[data-cart-action="quantity-select"]')) {
          this.handleQuantitySelectChange(target);
          return;
        }

        if (target.matches('[data-cart-action="selling-plan"]')) {
          this.handleSellingPlanChange(target);
        }
      }

      handleKeydown(event) {
        if (event.key !== 'Enter') {
          return;
        }

        const target = event.target;

        if (!(target instanceof HTMLElement)) {
          return;
        }

        if (target.matches('[data-cart-discount-input]')) {
          event.preventDefault();
          this.handleApplyDiscount();
        }
      }
    }

    function initializeMainCart(root) {
      if (!root) {
        return null;
      }

      const existing = instances.get(root);

      if (existing) {
        return existing;
      }

      const instance = new MainCart(root);
      instances.set(root, instance);
      return instance;
    }

    function destroyMainCart(root) {
      const instance = instances.get(root);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(root);
    }

    document.querySelectorAll('.js-main-cart').forEach((root) => initializeMainCart(root));

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const root = event.target.matches('.js-main-cart') ? event.target : event.target.querySelector('.js-main-cart');

        initializeMainCart(root);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const root = event.target.matches('.js-main-cart') ? event.target : event.target.querySelector('.js-main-cart');

        destroyMainCart(root);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"] && !Shopify.designMode) return;
  try {
    
  class ProductsSliderCarousel extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.embla = null;
      this.resizeTimeout = null;
      this.updateUiBound = this.updateUI.bind(this);
    }

    connectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.viewport = this.querySelector('[data-products-viewport]');
      this.prevButton = this.querySelector('[data-products-prev]');
      this.nextButton = this.querySelector('[data-products-next]');
      this.progressIndicator = this.querySelector('[data-products-progress-indicator]');
      this.controls = this.querySelector('.products-slider__controls');

      if (!this.viewport) return;

      this.destroyEmbla();
      this.initialize();
      this.bindBaseEvents();
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }

      this.destroyEmbla();
    }

    async initialize() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.updateControlsForReducedMotion();
        return;
      }

      try {
        await this.loadEmbla();
        this.createEmbla();
      } catch (error) {
        console.error('Products slider Embla failed to load:', error);
      }
    }

    loadScriptOnce(promiseKey, globalName, src) {
      if (window[globalName]) return Promise.resolve();
      if (window[promiseKey]) return window[promiseKey];

      window[promiseKey] = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[data-asset-src="${src}"]`);

        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.dataset.assetSrc = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window[promiseKey];
    }

    loadEmbla() {
      const emblaSrc = this.dataset.emblaSrc;
      return this.loadScriptOnce('__rhealEmblaCorePromise', 'EmblaCarousel', emblaSrc);
    }

    createEmbla() {
      if (typeof EmblaCarousel !== 'function') return;

      const loop = this.dataset.loop === 'true';

      this.embla = EmblaCarousel(this.viewport, {
        loop,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
      });

      this.embla.on('select', this.updateUiBound);
      this.embla.on('reInit', this.updateUiBound);
      this.embla.on('scroll', this.updateUiBound);

      this.updateUI();
    }

    bindBaseEvents() {
      const { signal } = this.abortController;

      if (this.prevButton) {
        this.prevButton.addEventListener(
          'click',
          () => {
            if (!this.embla) return;
            this.embla.scrollPrev();
          },
          { signal }
        );
      }

      if (this.nextButton) {
        this.nextButton.addEventListener(
          'click',
          () => {
            if (!this.embla) return;
            this.embla.scrollNext();
          },
          { signal }
        );
      }

      window.addEventListener(
        'resize',
        () => {
          if (!this.embla) return;

          if (this.resizeTimeout) {
            window.clearTimeout(this.resizeTimeout);
          }

          this.resizeTimeout = window.setTimeout(() => {
            this.embla.reInit();
          }, 120);
        },
        { signal }
      );
    }

    updateControlsForReducedMotion() {
      if (this.prevButton) {
        this.prevButton.disabled = true;
        this.prevButton.setAttribute('aria-disabled', 'true');
      }

      if (this.nextButton) {
        this.nextButton.disabled = true;
        this.nextButton.setAttribute('aria-disabled', 'true');
      }

      if (this.progressIndicator) {
        this.progressIndicator.style.transform = 'scaleX(1)';
      }
    }

    updateButtons() {
      if (!this.embla) return;

      const canScrollPrev = this.embla.canScrollPrev();
      const canScrollNext = this.embla.canScrollNext();
      const canScroll = canScrollPrev || canScrollNext;

      if (this.prevButton) {
        this.prevButton.disabled = !canScrollPrev;
        this.prevButton.setAttribute('aria-disabled', String(!canScrollPrev));
      }

      if (this.nextButton) {
        this.nextButton.disabled = !canScrollNext;
        this.nextButton.setAttribute('aria-disabled', String(!canScrollNext));
      }

      const controls = this.querySelector('.products-slider__controls');
      if (controls) {
        controls.hidden = !canScroll;
      }

      if (this.viewport) {
        this.viewport.classList.toggle('products-slider__viewport--centered', !canScroll);
      }
    }

    updateProgress() {
      if (!this.embla || !this.progressIndicator) return;

      const snapCount = this.embla.scrollSnapList().length;
      let progress;

      if (snapCount <= 1) {
        progress = 1;
      } else if (this.dataset.loop === 'true') {
        progress = this.embla.selectedScrollSnap() / (snapCount - 1);
      } else {
        progress = this.embla.scrollProgress();
      }

      progress = Math.max(0, Math.min(1, progress));
      const base = 1 / snapCount;
      progress = base + progress * (1 - base);
      this.progressIndicator.style.transform = 'scaleX(' + progress + ')';
    }

    updateUI() {
      if (!this.embla) return;

      const canScroll = this.embla.canScrollPrev() || this.embla.canScrollNext();

      if (this.controls) {
        this.controls.style.display = canScroll ? '' : 'none';
      }

      if (canScroll) {
        this.updateButtons();

        if (this.dataset.showProgress === 'true') {
          this.updateProgress();
        }
      }
    }

    destroyEmbla() {
      if (this.embla && typeof this.embla.destroy === 'function') {
        this.embla.destroy();
      }

      this.embla = null;
    }
  }

  if (!customElements.get('products-slider-carousel')) {
    customElements.define('products-slider-carousel', ProductsSliderCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-ingredients-carousel"] && !Shopify.designMode) return;
  try {
    
  class RealIngredientsCarousel extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.embla = null;
      this.resizeTimeout = null;
    }

    connectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.viewport = this.querySelector('[data-ingredients-viewport]');

      if (!this.viewport) return;

      this.destroyEmbla();
      this.initialize();
      this.bindEvents();
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }

      this.destroyEmbla();
    }

    async initialize() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      try {
        await this.loadEmbla();
        this.createEmbla();
      } catch (error) {
        console.error('Real Ingredients carousel Embla failed to load:', error);
      }
    }

    loadScriptOnce(promiseKey, globalName, src) {
      if (window[globalName]) return Promise.resolve();
      if (window[promiseKey]) return window[promiseKey];

      window[promiseKey] = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[data-asset-src="${src}"]`);

        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.dataset.assetSrc = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window[promiseKey];
    }

    loadEmbla() {
      const emblaSrc = this.dataset.emblaSrc;
      return this.loadScriptOnce('__rhealEmblaCorePromise', 'EmblaCarousel', emblaSrc);
    }

    createEmbla() {
      if (typeof EmblaCarousel !== 'function') return;

      const loop = this.dataset.loop === 'true';
      const align = this.dataset.align || 'start';
      const dragFree = this.dataset.dragFree === 'true';

      this.embla = EmblaCarousel(this.viewport, {
        loop,
        align,
        dragFree,
        containScroll: 'trimSnaps',
      });

      this.embla.on('reInit', () => this.updateCentering());
      this.updateCentering();
    }

    updateCentering() {
      if (!this.embla || !this.viewport) return;
      const canScroll = this.embla.canScrollPrev() || this.embla.canScrollNext();
      this.viewport.classList.toggle('real-ingredients__viewport--centered', !canScroll);
    }

    bindEvents() {
      const { signal } = this.abortController;

      window.addEventListener(
        'resize',
        () => {
          if (!this.embla) return;

          if (this.resizeTimeout) {
            window.clearTimeout(this.resizeTimeout);
          }

          this.resizeTimeout = window.setTimeout(() => {
            this.embla.reInit();
          }, 120);
        },
        { signal }
      );

      document.addEventListener(
        'shopify:block:select',
        (event) => {
          if (!this.embla || !this.contains(event.target)) return;

          const selectedSlide = event.target.closest('[data-ingredients-slide]');
          if (!selectedSlide) return;

          const slides = Array.from(this.querySelectorAll('[data-ingredients-slide]'));
          const targetIndex = slides.indexOf(selectedSlide);

          if (targetIndex < 0) return;
          this.embla.scrollTo(targetIndex, true);
        },
        { signal }
      );
    }

    destroyEmbla() {
      if (this.embla && typeof this.embla.destroy === 'function') {
        this.embla.destroy();
      }

      this.embla = null;
    }
  }

  if (!customElements.get('real-ingredients-carousel')) {
    customElements.define('real-ingredients-carousel', RealIngredientsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-timer-bar"] && !Shopify.designMode) return;
  try {
    
  class SaleTimerBar extends HTMLElement {
    connectedCallback() {
      this.timerDisplay = this.querySelector('[data-timer-display]');
      this.mode = this.dataset.mode;
      this.expiredAction = this.dataset.expiredAction;
      this.interval = null;

      this.endTimestamp = this.resolveEndTimestamp();

      if (this.endTimestamp === null) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.interval = window.setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) window.clearInterval(this.interval);
    }

    resolveEndTimestamp() {
      if (this.mode === 'daily') {
        return this.nextMidnight();
      }

      var fixedEnd = Date.parse(this.dataset.end);
      return isNaN(fixedEnd) ? null : fixedEnd;
    }

    nextMidnight() {
      var now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0).getTime();
    }

    tick() {
      var remaining = this.endTimestamp - Date.now();

      if (remaining <= 0) {
        if (this.mode === 'daily') {
          this.endTimestamp = this.nextMidnight();
          remaining = this.endTimestamp - Date.now();
        } else {
          this.renderTime(0);
          if (this.interval) window.clearInterval(this.interval);
          if (this.expiredAction === 'hide') this.hidden = true;
          return;
        }
      }

      this.renderTime(remaining);
    }

    renderTime(remainingMs) {
      if (!this.timerDisplay) return;

      var totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      var pad = function(value) {
        return String(value).padStart(2, '0');
      };

      this.timerDisplay.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }
  }

  if (!customElements.get('sale-timer-bar')) {
    customElements.define('sale-timer-bar', SaleTimerBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-product-bar"]) return;
  try {
    
  class StickyProductBar extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.lastScrollY = window.scrollY;
      this.heroInView = true;
      this.footerInView = false;
      this.ticking = false;
    }

    connectedCallback() {
      this.removeAttribute('hidden');
      this.syncReviewsFromHero();

      var signal = this.abortController.signal;

      this.setupHeroObserver();
      this.setupFooterObserver();
      this.setupScrollListener(signal);
      this.setupCtaClick(signal);
    }

    syncReviewsFromHero() {
      var heroBlock = document.querySelector('.product-hero__review-link');
      if (!heroBlock || getComputedStyle(heroBlock).display === 'none') return;

      var heroText = heroBlock.querySelector('.product-hero__review-link-text');
      if (!heroText) return;

      var text = heroText.textContent.trim();
      if (!text) return;

      var template = this.querySelector('[data-reviews-template]');
      if (!template) return;

      var clone = template.content.cloneNode(true);
      clone.querySelector('.sticky-product-bar__review-text').textContent = text;
      this.querySelector('.sticky-product-bar__info').appendChild(clone);
      template.remove();
    }

    disconnectedCallback() {
      this.abortController.abort();
      if (this.heroObserver) this.heroObserver.disconnect();
      if (this.footerObserver) this.footerObserver.disconnect();
    }

    observeElement(selector, prop) {
      var el = document.querySelector(selector);
      if (!el) { this[prop] = false; return null; }

      var observer = new IntersectionObserver(function(entries) {
        this[prop] = entries[0].isIntersecting;
        this.updateVisibility();
      }.bind(this), { threshold: 0 });

      observer.observe(el);
      return observer;
    }

    setupHeroObserver() {
      this.heroObserver = this.observeElement('.product-hero', 'heroInView');
    }

    setupFooterObserver() {
      this.footerObserver = this.observeElement('footer', 'footerInView');
    }

    setupScrollListener(signal) {
      window.addEventListener('scroll', function() {
        if (!this.ticking) {
          requestAnimationFrame(function() {
            this.onScroll();
            this.ticking = false;
          }.bind(this));
          this.ticking = true;
        }
      }.bind(this), { passive: true, signal: signal });
    }

    onScroll() {
      var currentScrollY = window.scrollY;
      this.scrollingDown = currentScrollY > this.lastScrollY;
      this.lastScrollY = currentScrollY;
      this.updateVisibility();
    }

    updateVisibility() {
      var shouldShow = this.scrollingDown && !this.heroInView && !this.footerInView;

      if (shouldShow) {
        this.setAttribute('data-visible', '');
      } else {
        this.removeAttribute('data-visible');
      }
    }

    setupCtaClick(signal) {
      var cta = this.querySelector('[data-sticky-bar-cta]');
      if (!cta) return;

      cta.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, { signal: signal });
    }
  }

  if (!customElements.get('sticky-product-bar')) {
    customElements.define('sticky-product-bar', StickyProductBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-info-panel"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionInfoPanel extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.triggerElement = null;
    }

    connectedCallback() {
      const { signal } = this.abortController;

      this.overlay = this.querySelector('[data-overlay]');
      this.drawer = this.querySelector('[data-drawer]');
      this.closeButton = this.querySelector('[data-close]');

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-subscription-panel-trigger]');
        if (trigger) {
          e.preventDefault();
          this.open(trigger);
        }
      }, { signal });

      this.overlay.addEventListener('click', () => this.close(), { signal });
      this.closeButton.addEventListener('click', () => this.close(), { signal });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) {
          this.close();
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open(trigger) {
      this.triggerElement = trigger;
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      this.closeButton.focus();
    }

    close() {
      this.drawer.classList.add('is-closing');
      this.removeAttribute('open');
      document.body.style.overflow = '';

      const onDone = () => {
        this.drawer.classList.remove('is-closing');
        this.drawer.removeEventListener('transitionend', onDone);
      };
      this.drawer.addEventListener('transitionend', onDone, { once: true });

      if (this.triggerElement) {
        this.triggerElement.focus();
        this.triggerElement = null;
      }
    }
  }

  if (!customElements.get('subscription-info-panel')) {
    customElements.define('subscription-info-panel', SubscriptionInfoPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-faq"] && !Shopify.designMode) return;
  try {
    
  class SupportFaq extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.runningAnimations = new WeakMap();
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      if (this.abortController.signal.aborted) {
        this.abortController = new AbortController();
      }

      this.initialize();
    }

    initialize() {
      const accordion = this.querySelector('[data-support-faq-accordion]');
      if (!accordion) return;

      const isSingleOpen = accordion.dataset.singleOpen === 'true';
      const items = Array.from(accordion.querySelectorAll('.support-faq__item'));
      if (!items.length) return;

      const { signal } = this.abortController;

      items.forEach((item) => {
        const panel = item.querySelector('.support-faq__panel');
        if (!panel) return;

        if (item.open) {
          panel.style.height = 'auto';
          panel.style.opacity = '1';
        } else {
          panel.style.height = '0px';
          panel.style.opacity = '0';
        }

        const trigger = item.querySelector('.support-faq__trigger');
        if (!trigger) return;

        trigger.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            this.toggleItem(item, items, isSingleOpen);
          },
          { signal }
        );
      });
    }

    toggleItem(item, items, isSingleOpen) {
      if (this.runningAnimations.get(item)) return;

      if (item.open) {
        this.closeItem(item);
        return;
      }

      if (isSingleOpen) {
        items.forEach((otherItem) => {
          if (otherItem !== item && otherItem.open) {
            this.closeItem(otherItem);
          }
        });
      }

      this.openItem(item);
    }

    openItem(item) {
      const panel = item.querySelector('.support-faq__panel');
      if (!panel) return;

      const currentAnimation = this.runningAnimations.get(item);
      if (currentAnimation) {
        panel.removeEventListener('transitionend', currentAnimation);
      }

      item.open = true;
      panel.style.transition = 'none';
      panel.style.height = '0px';
      panel.style.opacity = '0';
      void panel.offsetHeight;

      const targetHeight = panel.scrollHeight;
      if (this.prefersReducedMotion) {
        panel.style.transition = '';
        panel.style.height = 'auto';
        panel.style.opacity = '1';
        this.runningAnimations.delete(item);
        return;
      }

      panel.style.transition = 'height 320ms cubic-bezier(0.4, 0, 0.2, 1), opacity 220ms cubic-bezier(0.4, 0, 0.2, 1)';
      panel.style.height = `${targetHeight}px`;
      panel.style.opacity = '1';

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        panel.style.transition = '';
        panel.style.height = 'auto';
        this.runningAnimations.delete(item);
        panel.removeEventListener('transitionend', onEnd);
      };

      this.runningAnimations.set(item, onEnd);
      panel.addEventListener('transitionend', onEnd);
    }

    closeItem(item) {
      const panel = item.querySelector('.support-faq__panel');
      if (!panel) return;

      const currentAnimation = this.runningAnimations.get(item);
      if (currentAnimation) {
        panel.removeEventListener('transitionend', currentAnimation);
      }

      const startHeight = panel.offsetHeight;
      panel.style.transition = 'none';
      panel.style.height = `${startHeight}px`;
      panel.style.opacity = '1';
      void panel.offsetHeight;

      panel.style.transition = 'height 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)';
      panel.style.height = '0px';
      panel.style.opacity = '0';

      if (this.prefersReducedMotion) {
        item.open = false;
        panel.style.transition = '';
        panel.style.height = '0px';
        this.runningAnimations.delete(item);
        return;
      }

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        item.open = false;
        panel.style.transition = '';
        panel.style.height = '0px';
        this.runningAnimations.delete(item);
        panel.removeEventListener('transitionend', onEnd);
      };

      this.runningAnimations.set(item, onEnd);
      panel.addEventListener('transitionend', onEnd);
    }

    disconnectedCallback() {
      const panels = this.querySelectorAll('.support-faq__panel');
      panels.forEach((panel) => {
        panel.style.transition = '';
      });

      this.runningAnimations = new WeakMap();
      this.abortController.abort();
    }
  }

  if (!customElements.get('support-faq')) {
    customElements.define('support-faq', SupportFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarouselSlider extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.embla = null;
      this.resizeTimeout = null;
      this.updateUiBound = this.updateUI.bind(this);
    }

    connectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.viewport = this.querySelector('[data-testimonial-viewport]');
      this.prevButton = this.querySelector('[data-testimonial-prev]');
      this.nextButton = this.querySelector('[data-testimonial-next]');
      this.progressIndicator = this.querySelector('[data-testimonial-progress-indicator]');
      this.controls = this.querySelector('.testimonial-carousel__controls');

      if (!this.viewport) return;

      this.destroyEmbla();
      this.initialize();
      this.bindBaseEvents();
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }

      this.destroyEmbla();
    }

    async initialize() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.updateControlsForReducedMotion();
        return;
      }

      try {
        await this.loadEmbla();
        this.createEmbla();
      } catch (error) {
        console.error('Testimonial carousel Embla failed to load:', error);
      }
    }

    loadScriptOnce(promiseKey, globalName, src) {
      if (window[globalName]) return Promise.resolve();
      if (window[promiseKey]) return window[promiseKey];

      window[promiseKey] = new Promise((resolve, reject) => {
        const existingScript = document.querySelector('[data-asset-src="' + src + '"]');

        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.dataset.assetSrc = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window[promiseKey];
    }

    loadEmbla() {
      const emblaSrc = this.dataset.emblaSrc;
      return this.loadScriptOnce('__rhealEmblaCorePromise', 'EmblaCarousel', emblaSrc);
    }

    createEmbla() {
      if (typeof EmblaCarousel !== 'function') return;

      const loop = this.dataset.loop === 'true';

      this.embla = EmblaCarousel(this.viewport, {
        loop,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        slidesToScroll: 1
      });

      this.embla.on('select', this.updateUiBound);
      this.embla.on('reInit', this.updateUiBound);
      this.embla.on('scroll', this.updateUiBound);

      this.updateUI();
    }

    bindBaseEvents() {
      const { signal } = this.abortController;

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          if (!this.embla) return;
          this.embla.scrollPrev();
        }, { signal });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          if (!this.embla) return;
          this.embla.scrollNext();
        }, { signal });
      }

      window.addEventListener('resize', () => {
        if (!this.embla) return;

        if (this.resizeTimeout) {
          window.clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = window.setTimeout(() => {
          this.embla.reInit();
        }, 120);
      }, { signal });
    }

    updateControlsForReducedMotion() {
      if (this.prevButton) {
        this.prevButton.disabled = true;
        this.prevButton.setAttribute('aria-disabled', 'true');
      }

      if (this.nextButton) {
        this.nextButton.disabled = true;
        this.nextButton.setAttribute('aria-disabled', 'true');
      }

      if (this.progressIndicator) {
        this.progressIndicator.style.transform = 'scaleX(1)';
      }
    }

    updateButtons() {
      if (!this.embla) return;

      const canScrollPrev = this.embla.canScrollPrev();
      const canScrollNext = this.embla.canScrollNext();

      if (this.prevButton) {
        this.prevButton.disabled = !canScrollPrev;
        this.prevButton.setAttribute('aria-disabled', String(!canScrollPrev));
      }

      if (this.nextButton) {
        this.nextButton.disabled = !canScrollNext;
        this.nextButton.setAttribute('aria-disabled', String(!canScrollNext));
      }
    }

    updateProgress() {
      if (!this.embla || !this.progressIndicator) return;

      var snapCount = this.embla.scrollSnapList().length;
      var progress;

      if (snapCount <= 1) {
        progress = 1;
      } else if (this.dataset.loop === 'true') {
        progress = this.embla.selectedScrollSnap() / (snapCount - 1);
      } else {
        progress = this.embla.scrollProgress();
      }

      progress = Math.max(0, Math.min(1, progress));
      var base = 1 / snapCount;
      progress = base + progress * (1 - base);
      this.progressIndicator.style.transform = 'scaleX(' + progress + ')';
    }

    updateUI() {
      if (!this.embla) return;

      const canScroll = this.embla.canScrollPrev() || this.embla.canScrollNext();

      if (this.controls) {
        this.controls.style.display = canScroll ? '' : 'none';
      }

      if (canScroll) {
        this.updateButtons();

        if (this.dataset.showProgress === 'true') {
          this.updateProgress();
        }
      }
    }

    destroyEmbla() {
      if (this.embla && typeof this.embla.destroy === 'function') {
        this.embla.destroy();
      }

      this.embla = null;
    }
  }

  if (!customElements.get('testimonial-carousel-slider')) {
    customElements.define('testimonial-carousel-slider', TestimonialCarouselSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
  class TrustpilotReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.embla = null;
      this.resizeTimeout = null;
      this.updateUiBound = this.updateUI.bind(this);
    }

    connectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.viewport = this.querySelector('[data-reviews-viewport]');
      this.prevButton = this.querySelector('[data-reviews-prev]');
      this.nextButton = this.querySelector('[data-reviews-next]');
      this.progressIndicator = this.querySelector('[data-reviews-progress-indicator]');
      this.controls = this.querySelector('.trustpilot-reviews__controls');

      if (!this.viewport) return;

      this.destroyEmbla();
      this.initialize();
      this.bindBaseEvents();
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }

      this.destroyEmbla();
    }

    async initialize() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.updateControlsForReducedMotion();
        return;
      }

      try {
        await this.loadEmbla();
        this.createEmbla();
      } catch (error) {
        console.error('Trustpilot reviews Embla failed to load:', error);
      }
    }

    loadScriptOnce(promiseKey, globalName, src) {
      if (window[globalName]) return Promise.resolve();
      if (window[promiseKey]) return window[promiseKey];

      window[promiseKey] = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[data-asset-src="${src}"]`);

        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.dataset.assetSrc = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window[promiseKey];
    }

    loadEmbla() {
      const emblaSrc = this.dataset.emblaSrc;
      return this.loadScriptOnce('__rhealEmblaCorePromise', 'EmblaCarousel', emblaSrc);
    }

    createEmbla() {
      if (typeof EmblaCarousel !== 'function') return;

      const loop = this.dataset.loop === 'true';

      this.embla = EmblaCarousel(this.viewport, {
        loop,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        slidesToScroll: 1,
      });

      this.embla.on('select', this.updateUiBound);
      this.embla.on('reInit', this.updateUiBound);
      this.embla.on('scroll', this.updateUiBound);

      this.updateUI();
    }

    bindBaseEvents() {
      const { signal } = this.abortController;

      if (this.prevButton) {
        this.prevButton.addEventListener(
          'click',
          () => {
            if (!this.embla) return;
            this.embla.scrollPrev();
          },
          { signal }
        );
      }

      if (this.nextButton) {
        this.nextButton.addEventListener(
          'click',
          () => {
            if (!this.embla) return;
            this.embla.scrollNext();
          },
          { signal }
        );
      }

      window.addEventListener(
        'resize',
        () => {
          if (!this.embla) return;

          if (this.resizeTimeout) {
            window.clearTimeout(this.resizeTimeout);
          }

          this.resizeTimeout = window.setTimeout(() => {
            this.embla.reInit();
          }, 120);
        },
        { signal }
      );
    }

    updateControlsForReducedMotion() {
      if (this.prevButton) {
        this.prevButton.disabled = true;
        this.prevButton.setAttribute('aria-disabled', 'true');
      }

      if (this.nextButton) {
        this.nextButton.disabled = true;
        this.nextButton.setAttribute('aria-disabled', 'true');
      }

      if (this.progressIndicator) {
        this.progressIndicator.style.transform = 'scaleX(1)';
      }
    }

    updateButtons() {
      if (!this.embla) return;

      const canScrollPrev = this.embla.canScrollPrev();
      const canScrollNext = this.embla.canScrollNext();

      if (this.prevButton) {
        this.prevButton.disabled = !canScrollPrev;
        this.prevButton.setAttribute('aria-disabled', String(!canScrollPrev));
      }

      if (this.nextButton) {
        this.nextButton.disabled = !canScrollNext;
        this.nextButton.setAttribute('aria-disabled', String(!canScrollNext));
      }
    }

    updateProgress() {
      if (!this.embla || !this.progressIndicator) return;

      const snapCount = this.embla.scrollSnapList().length;
      let progress;

      if (snapCount <= 1) {
        progress = 1;
      } else if (this.dataset.loop === 'true') {
        progress = this.embla.selectedScrollSnap() / (snapCount - 1);
      } else {
        progress = this.embla.scrollProgress();
      }

      progress = Math.max(0, Math.min(1, progress));
      const base = 1 / snapCount;
      progress = base + progress * (1 - base);
      this.progressIndicator.style.transform = 'scaleX(' + progress + ')';
    }

    updateUI() {
      if (!this.embla) return;

      const canScroll = this.embla.canScrollPrev() || this.embla.canScrollNext();

      if (this.controls) {
        this.controls.style.display = canScroll ? '' : 'none';
      }

      if (canScroll) {
        this.updateButtons();

        if (this.dataset.showProgress === 'true') {
          this.updateProgress();
        }
      }
    }

    destroyEmbla() {
      if (this.embla && typeof this.embla.destroy === 'function') {
        this.embla.destroy();
      }

      this.embla = null;
    }
  }

  if (!customElements.get('trustpilot-reviews-carousel')) {
    customElements.define('trustpilot-reviews-carousel', TrustpilotReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoCarouselSlider extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.embla = null;
      this.resizeTimeout = null;
      this.updateUiBound = this.updateUI.bind(this);
    }

    connectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.viewport = this.querySelector('[data-video-viewport]');
      this.prevButton = this.querySelector('[data-video-prev]');
      this.nextButton = this.querySelector('[data-video-next]');
      this.progressIndicator = this.querySelector('[data-video-progress-indicator]');
      this.controls = this.querySelector('.video-carousel__controls');

      if (!this.viewport) return;

      this.destroyEmbla();
      this.initialize();
      this.bindBaseEvents();
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }

      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }

      this.destroyEmbla();
    }

    async initialize() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.updateControlsForReducedMotion();
        return;
      }

      try {
        await this.loadEmbla();
        this.createEmbla();
      } catch (error) {
        console.error('Video carousel Embla failed to load:', error);
      }
    }

    loadScriptOnce(promiseKey, globalName, src) {
      if (window[globalName]) return Promise.resolve();
      if (window[promiseKey]) return window[promiseKey];

      window[promiseKey] = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[data-asset-src="${src}"]`);

        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.dataset.assetSrc = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window[promiseKey];
    }

    loadEmbla() {
      const emblaSrc = this.dataset.emblaSrc;
      return this.loadScriptOnce('__rhealEmblaCorePromise', 'EmblaCarousel', emblaSrc);
    }

    createEmbla() {
      if (typeof EmblaCarousel !== 'function') return;

      const loop = this.dataset.loop === 'true';

      this.embla = EmblaCarousel(this.viewport, {
        loop,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
      });

      this.embla.on('select', this.updateUiBound);
      this.embla.on('reInit', this.updateUiBound);
      this.embla.on('scroll', this.updateUiBound);

      this.updateUI();
    }

    bindBaseEvents() {
      const { signal } = this.abortController;

      if (this.prevButton) {
        this.prevButton.addEventListener(
          'click',
          () => {
            if (!this.embla) return;
            this.embla.scrollPrev();
          },
          { signal }
        );
      }

      if (this.nextButton) {
        this.nextButton.addEventListener(
          'click',
          () => {
            if (!this.embla) return;
            this.embla.scrollNext();
          },
          { signal }
        );
      }

      window.addEventListener(
        'resize',
        () => {
          if (!this.embla) return;

          if (this.resizeTimeout) {
            window.clearTimeout(this.resizeTimeout);
          }

          this.resizeTimeout = window.setTimeout(() => {
            this.embla.reInit();
          }, 120);
        },
        { signal }
      );
    }

    updateControlsForReducedMotion() {
      if (this.prevButton) {
        this.prevButton.disabled = true;
        this.prevButton.setAttribute('aria-disabled', 'true');
      }

      if (this.nextButton) {
        this.nextButton.disabled = true;
        this.nextButton.setAttribute('aria-disabled', 'true');
      }

      if (this.progressIndicator) {
        this.progressIndicator.style.transform = 'scaleX(1)';
      }
    }

    updateButtons() {
      if (!this.embla) return;

      const canScrollPrev = this.embla.canScrollPrev();
      const canScrollNext = this.embla.canScrollNext();

      if (this.prevButton) {
        this.prevButton.disabled = !canScrollPrev;
        this.prevButton.setAttribute('aria-disabled', String(!canScrollPrev));
      }

      if (this.nextButton) {
        this.nextButton.disabled = !canScrollNext;
        this.nextButton.setAttribute('aria-disabled', String(!canScrollNext));
      }
    }

    updateProgress() {
      if (!this.embla || !this.progressIndicator) return;

      const snapCount = this.embla.scrollSnapList().length;
      let progress;

      if (snapCount <= 1) {
        progress = 1;
      } else if (this.dataset.loop === 'true') {
        progress = this.embla.selectedScrollSnap() / (snapCount - 1);
      } else {
        progress = this.embla.scrollProgress();
      }

      progress = Math.max(0, Math.min(1, progress));
      const base = 1 / snapCount;
      progress = base + progress * (1 - base);
      this.progressIndicator.style.transform = 'scaleX(' + progress + ')';
    }

    updateUI() {
      if (!this.embla) return;

      const canScroll = this.embla.canScrollPrev() || this.embla.canScrollNext();

      if (this.controls) {
        this.controls.style.display = canScroll ? '' : 'none';
      }

      if (canScroll) {
        this.updateButtons();

        if (this.dataset.showProgress === 'true') {
          this.updateProgress();
        }
      }
    }

    destroyEmbla() {
      if (this.embla && typeof this.embla.destroy === 'function') {
        this.embla.destroy();
      }

      this.embla = null;
    }
  }

  if (!customElements.get('video-carousel-slider')) {
    customElements.define('video-carousel-slider', VideoCarouselSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
